<div
  class="input-wrapper"
  [class.clickable-container]="isAbleToSelectStaff()"
  (click)="openStaffSelectionDialog()"
>
  <div>{{ selectedStaff | staffNameFormatter : selectedStaffId }}</div>
  <mat-icon *ngIf="isAbleToSelectStaff()" color="primary"
    >arrow_drop_down</mat-icon
  >
</div>
